import { useNavigate } from "react-router-dom"

import APP_ICON from "@/assets/nfwf-logo.png"
import { UserButton } from "@/components/buttons/UserButton"
import { AccountSelection } from "@/components/selections/AccountSelection"
import { ProjectSelection } from "@/components/selections/ProjectSelection"
import { Breadcrumb, BreadcrumbItem, BreadcrumbList } from "@ui/breadcrumb"
import { Button } from "@ui/button"
import { Separator } from "@ui/separator"
import { SidebarTrigger, useSidebar } from "@ui/sidebar"

export function ApplicationHeader() {
    const navigate = useNavigate()

    const handleNavigateHome = () => {
        navigate("/")
    }

    return (
        <header className="z-50 w-full items-center border-b border-gray-300 bg-background">
            <div className="flex h-[var(--header-height)] w-full items-center justify-between px-2">
                <div className='flex items-center gap-2'>
                    <Button
                        className='w-[120px]'
                        variant="ghost"
                        size="icon"
                        onClick={handleNavigateHome}
                    >
                        <img src={APP_ICON} alt="Vertesia logo" />
                    </Button>
                    <Separator orientation="vertical" className="h-4" />
                    <SidebarTrigger />
                    <Separator orientation="vertical" className="h-4" />
                    <Breadcrumb className="hidden sm:block">
                        <BreadcrumbList>
                            <BreadcrumbItem>
                                <AccountSelection />
                            </BreadcrumbItem>
                            <Separator orientation="vertical" className="h-4" />
                            <BreadcrumbItem>
                                <ProjectSelection />
                            </BreadcrumbItem>
                        </BreadcrumbList>
                    </Breadcrumb>
                </div>
                <UserButton />
            </div>
        </header>
    )
}
